<template>
  <OrgExternalDonorsProvider :orgCustomerID="orgCustomerID" :page="page" :per_page="per_page">
    <template #default="{ list, loading, errors, total, onPageChange, page }">
      <b-alert v-if="errors.length" variant="danger" show>
        <span v-for="(errMsg, index) in errors" :key="index">
          {{ errMsg }}
        </span>
      </b-alert>

      <div v-else>
        <b-table head-variant="light" :busy="loading" :items="list" :fields="fields">
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(name)="data">
            {{ data.item.first_name }} {{ data.item.last_name }}
          </template>
        </b-table>

        <div class="pagination">
          <b-pagination
            :total-rows="total"
            :value="page"
            :per-page="per_page"
            @change="onPageChange"
            size="sm"
          >
          </b-pagination>
        </div>
      </div>
    </template>
  </OrgExternalDonorsProvider>
</template>

<script>
import { defineComponent } from "vue";
import OrgExternalDonorsProvider from "./OrgExternalDonorsProvider.vue";

export default defineComponent({
  components: {
    OrgExternalDonorsProvider,
  },
  data() {
    return {
      page: 1,
      per_page: 15,
      fields: [
        {
          key: "id",
          label: this.$t("dashboard.org_ticket_id", "ID"),
        },
        {
          key: "name",
          label: this.$t("dashboard.org_external_donors_name", "Name"),
        },
        {
          key: "display_name",
          label: this.$t("dashboard.org_external_donors_display_name", "Display Name"),
        },
        {
          key: "email",
          label: this.$t("dashboard.org_external_donors_email", "Email"),
        },
        {
          key: "phone",
          label: this.$t("dashboard.org_external_donors_phone", "Phone"),
        },
        {
          key: "created_at",
          formatter: (value) => {
            return new Date(value).toLocaleString();
          },
          label: this.$t("dashboard.org_external_donors_created_at", "Created At"),
        },
      ],
    };
  },
  computed: {
    orgCustomerID() {
      return localStorage.getItem("orgId");
    },
  },
  methods: {
    refresh() {
      this.$root.$emit("OrgExternalDonorsProvider:fetchData");
    },
  },
});
</script>
